import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Badge from '@material-ui/core/Badge';
import AppsIcon from '@material-ui/icons/Apps';
import PriorityHighIcon from '@material-ui/icons/PriorityHigh';
import NotificationsIcon from '@material-ui/icons/Notifications';
import MarkUnreadIcon from '@material-ui/icons/Markunread';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';
import { AppHeaderWrapper } from '../../../styles/header';
import { Popper, Grow, ClickAwayListener, MenuList, MenuItem } from '@material-ui/core';
import { getLocalStorageValue } from '../../../effects/utils/local-storage';
import { AuthenticationContext } from 'react-adal';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { logout } from 'src/actions/action.userAuth';
import { getNotifications, markAsReadNotification, getAdalConfig, clearAllNotification, getNotificationsCount } from 'src/effects/api/api.userAuth';
import { DATACOLLECTOR_IS_OFFLINE_ACTIVE_KEY, SYNC_SURVEY_GET_USER_COUNTRIES_KEY } from 'src/constants/constants';
import { setSurveyOfflineModeAction } from 'src/actions/action.module';
import { UserType } from 'src/constants/Enum/UserType';
import ConfirmationComponent from 'src/components/common//notification/ConfirmationComponent';
import { LOGOUT_WARNING_IN_OFFLINE_MODE_CONFIRAMATION } from 'src/constants/NotificationMessageConstant';
import { ApplicationMain } from 'src/styles/common';

class HeaderComponent extends React.Component<any, any>{
    static contextTypes = {
        router: PropTypes.object
    }

    anchorElMenu: any;
    anchorElNotification: any;

    constructor(props: any, context: any) {
        super(props, context);

        this.state = {
            open: false,
            showHeader: false,
            loggedInUser: {},
            notifications: [],
            notificationOpen: false,
            isOfflineModeActive: false,
            isConfirmDialogShow: false,
            notificationsCount: 0
        };

        this.handleClose = this.handleClose.bind(this);
        this.handleToggle = this.handleToggle.bind(this);
        this.handleCloseAway = this.handleCloseAway.bind(this);
        this.logoutUser = this.logoutUser.bind(this);
        this.sortMenu = this.sortMenu.bind(this);
        this.handleCloseNotification = this.handleCloseNotification.bind(this);
        this.navigateToResponse = this.navigateToResponse.bind(this);
        this.handleDialogLogoutInOfflineMode = this.handleDialogLogoutInOfflineMode.bind(this);
        this.onCloseConfirmation = this.onCloseConfirmation.bind(this);
        this.handleOpenInternalReportLink = this.handleOpenInternalReportLink.bind(this);
    }

    onCloseConfirmation() {
        this.setState({ isConfirmDialogShow: false });
    }

    setAnchorMenu = (node: any) => {
        this.anchorElMenu = node;
    };

    handleToggle = () => {
        this.setState({ open: !this.state.open });
    };

    handleClose = (link: any, event: any) => {
        this.setState({ open: false });
        this.context.router.history.push(link);
    };
    handleCloseAway = (event: any) => {
        this.setState({ open: false });
    };
    handleOpenInternalReportLink = (link: any, event: any) => {
        this.setState({ open: false });
        window.open(link)
    };

    setAnchorNotification = (node: any) => {
        this.anchorElNotification = node;
    };

    handleNotificationToggle = () => {
        let notifications: any = [];
        const notificationOpen: boolean = !this.state.notificationOpen
        if (notificationOpen) {
            getNotifications().then((res: any) => {
                if (res.data && res.data.success) {
                    notifications = res.data.payload;
                }

                this.setState({ notificationOpen, notifications });
            });
        } else {
            this.setState({ notificationOpen, notifications });
        }
    };

    handleCloseNotification = () => {
        this.setState({ notificationOpen: false });
    };

    handleCloseNotificationAway = (event: any) => {
        if (this.anchorElNotification.contains(event.target)) {
            return;
        }

        this.setState({ notificationOpen: false });
    };

    componentDidMount() {
        this.checkUserLoggedIn();
        this.showHideHeader();

        const loggedInUser = getLocalStorageValue('user');
        if (loggedInUser) {
            const isOfflineModeActive = getLocalStorageValue(`UserId_${loggedInUser.id}_${DATACOLLECTOR_IS_OFFLINE_ACTIVE_KEY}`);

            if (isOfflineModeActive) {
                if (!this.props.isOfflineModeActivated && loggedInUser.roleId === UserType.DataCollector) {
                    this.props.setSurveyOfflineMode(true);
                }
                this.setState({ isOfflineModeActive: true, notifications: [] });
            }
            else if (this.props.isOfflineModeActivated) {
                this.props.setSurveyOfflineMode(false);
            }
            else {
                let notificationsCount: number = 0;
                getNotificationsCount().then((res: any) => {
                    if (res.data && res.data.success) {
                        notificationsCount = res.data.payload;
                    }

                    this.setState({ notificationsCount });
                });

                this.setState({ isOfflineModeActive: false });
            }
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        const loggedInUser = getLocalStorageValue('user');
        this.checkTokenExpiry(loggedInUser);
        if (loggedInUser) {
            this.setState({ loggedInUser });

            const isOfflineModeActive = getLocalStorageValue(`UserId_${loggedInUser.id}_${DATACOLLECTOR_IS_OFFLINE_ACTIVE_KEY}`);
            if (isOfflineModeActive) {
                if (!nextProps.isOfflineModeActivated && loggedInUser.roleId === UserType.DataCollector) {
                    this.props.setSurveyOfflineMode(true);
                }
                this.setState({ isOfflineModeActive: true, notifications: [] });
            }
            else if (nextProps.isOfflineModeActivated) {
                this.props.setSurveyOfflineMode(false);
            }
            else {
                let notificationsCount: number = 0;
                getNotificationsCount().then((res: any) => {
                    if (res.data && res.data.success) {
                        notificationsCount = res.data.payload;
                    }

                    this.setState({ notificationsCount });
                });

                this.setState({ isOfflineModeActive: false });
            }
        }

        this.checkUserLoggedIn();
        this.showHideHeader();
    }

    componentWillUnmount() {
        const mountNode: any = ReactDOM.findDOMNode(this.refs.mount);

        try {
            if (mountNode) {
                ReactDOM.unmountComponentAtNode(mountNode);
            }
        } catch (e) {
            console.error(e);
        }
    }

    checkTokenExpiry = (loggedInUser: any) => {
        if (loggedInUser) {
            const jwtObject = this.parseJwt(loggedInUser.token);
            const tokenExpiryDate = new Date(jwtObject.exp * 1000);
            const currentDate = new Date();
            if (currentDate >= tokenExpiryDate) {
                if (loggedInUser) {
                    localStorage.removeItem(`UserId_${loggedInUser.id}_${SYNC_SURVEY_GET_USER_COUNTRIES_KEY}`)
                }
                localStorage.removeItem('user');
            }
        }

    }
    parseJwt(token: any) {
        const base64Url = token.split('.')[1];
        const base64 = decodeURIComponent(atob(base64Url).split('').map((c: any) => {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        return JSON.parse(base64);
    }

    showHideHeader() {
        const url = window.location.href.split('/');
        if (url[3] === 'login' || url[3] === 'register' || url[3] === 'forgotpassword' || url[3] === 'country-assignment') {
            this.setState({ showHeader: false });
        }
        else {
            this.setState({ showHeader: true });
        }
    }

    checkUserLoggedIn = () => {
        if (getLocalStorageValue('user')) {
            this.setState({ isUserLoggedIn: true });
        }
        else {
            this.setState({ isUserLoggedIn: false });
        }
    }

    logoutUser() {
        const loggedInUser = getLocalStorageValue('user');
        if (!this.state.isOfflineModeActive || !this.props.isOfflineModeActivated) {
            if (loggedInUser && loggedInUser.isInternalUser) {
                localStorage.removeItem(`UserId_${loggedInUser.id}_${SYNC_SURVEY_GET_USER_COUNTRIES_KEY}`)
                localStorage.removeItem('user');
                this.props.logout();

                getAdalConfig().then((adalConfig) => {
                    if (adalConfig) {
                        const authContext = new AuthenticationContext(adalConfig)
                        authContext.logOut();
                    }
                })

            }
            else {
                if (loggedInUser) {
                    localStorage.removeItem(`UserId_${loggedInUser.id}_${SYNC_SURVEY_GET_USER_COUNTRIES_KEY}`)
                }
                localStorage.removeItem('user');
                this.props.logout();
                this.props.redirectTo("/login");
            }
        }
        else if (loggedInUser) {
            this.setState({ isConfirmDialogShow: true });
        }
    };

    sortMenu() {
        if (this.state.loggedInUser.roleId === null || this.state.loggedInUser.roleId === undefined) {
            const loggedInUser = getLocalStorageValue('user');
            if (loggedInUser) {
                this.setState({ loggedInUser });
            }
        }

        if (this.state.loggedInUser && this.state.loggedInUser.roleId) {
            switch (this.state.loggedInUser.roleId) {
                case 1:
                    return (
                        <ClickAwayListener onClickAway={this.handleCloseAway}>
                            <MenuList className="appMenuList">
                                <MenuItem key={'Dashboard'} onClick={this.handleClose.bind(this, '/hq-admin-dashboard/0')}>Dashboard</MenuItem>
                                <MenuItem key={'Survey'} onClick={this.handleClose.bind(this, '/surveys')}>Survey Management</MenuItem>
                                <MenuItem key={'Reports'} onClick={this.handleClose.bind(this, '/surveyreports')}>Reports - External</MenuItem>
                                <MenuItem key={'Internal_Reports'} onClick={this.handleOpenInternalReportLink.bind(this,'https://unicef.sharepoint.com/sites/PD-NutriDash')}>Reports - Internal</MenuItem>
                                <MenuItem key={'Modules'} onClick={this.handleClose.bind(this, '/modules')}>Module Management</MenuItem>
                                <MenuItem key={'Users'} onClick={this.handleClose.bind(this, '/Users')}>Users Management</MenuItem>
                            </MenuList>
                        </ClickAwayListener>
                    )
                case 2:
                    return (
                        <ClickAwayListener onClickAway={this.handleCloseAway}>
                            <MenuList className="appMenuList">
                                <MenuItem key={'Dashboard'} onClick={this.handleClose.bind(this, '/regional-admin-dashboard/0')}>Dashboard</MenuItem>
                                <MenuItem key={'Survey'} onClick={this.handleClose.bind(this, '/surveys')}>Survey Management</MenuItem>
                                <MenuItem key={'Reports'} onClick={this.handleClose.bind(this, '/surveyreports')}>Reports - External</MenuItem>
                                <MenuItem key={'Internal_Reports'} onClick={this.handleOpenInternalReportLink.bind(this,'https://unicef.sharepoint.com/sites/PD-NutriDash')}>Reports - Internal</MenuItem>
                                <MenuItem key={'Modules'} onClick={this.handleClose.bind(this, '/modules')}>Module Management</MenuItem>
                                <MenuItem key={'Users'} onClick={this.handleClose.bind(this, '/Users')}>Users Management</MenuItem>
                            </MenuList>
                        </ClickAwayListener>
                    )
                case 3:
                    return (
                        <ClickAwayListener onClickAway={this.handleCloseAway}>
                            <MenuList className="appMenuList">
                                <MenuItem key={'Dashboard'} onClick={this.handleClose.bind(this, '/data-collector-dashboard/0')}>Dashboard</MenuItem>
                                <MenuItem key={'Reports'} onClick={this.handleClose.bind(this, '/surveyreports')}>Reports - External</MenuItem>
                                {this.state.loggedInUser.isInternalUser ?
                                    <MenuItem key={'Internal_Reports'} onClick={this.handleOpenInternalReportLink.bind(this,'https://unicef.sharepoint.com/sites/PD-NutriDash')}>Reports - Internal</MenuItem>
                                    : ''}
                            </MenuList>
                        </ClickAwayListener>
                    )
                case 4:
                    return (
                        <ClickAwayListener onClickAway={this.handleCloseAway}>
                            <MenuList className="appMenuList">
                                <MenuItem key={'Dashboard'} onClick={this.handleClose.bind(this, '/hq-admin-dashboard/0')}>Dashboard</MenuItem>
                                 <MenuItem key={'Reports'} onClick={this.handleClose.bind(this, '/surveyreports')}>Reports - External</MenuItem>
                            </MenuList>
                        </ClickAwayListener>
                    )
                case 5:
                    return (
                        <ClickAwayListener onClickAway={this.handleCloseAway}>
                            <MenuList className="appMenuList">
                                 <MenuItem key={'Reports'} onClick={this.handleClose.bind(this, '/surveyreports')}>Reports - External</MenuItem>
                            </MenuList>
                        </ClickAwayListener>
                    )
                case 6:
                    return (
                        <ClickAwayListener onClickAway={this.handleCloseAway}>
                            <MenuList className="appMenuList">
                                <MenuItem key={'Dashboard'} onClick={this.handleClose.bind(this, '/hq-admin-dashboard/0')}>Dashboard</MenuItem>
                                 <MenuItem key={'Reports'} onClick={this.handleClose.bind(this, '/surveyreports')}>Reports - External</MenuItem>
                            </MenuList>
                        </ClickAwayListener>
                    )
                case 7:
                    return (
                        <ClickAwayListener onClickAway={this.handleCloseAway}>
                            <MenuList className="appMenuList">
                                <MenuItem key={'Dashboard'} onClick={this.handleClose.bind(this, '/regional-admin-dashboard/0')}>Dashboard</MenuItem>
                                 <MenuItem key={'Reports'} onClick={this.handleClose.bind(this, '/surveyreports')}>Reports - External</MenuItem>
                            </MenuList>
                        </ClickAwayListener>
                    )
                case 8:
                    return (
                        <ClickAwayListener onClickAway={this.handleCloseAway}>
                            <MenuList className="appMenuList">
                                <MenuItem key={'Dashboard'} onClick={this.handleClose.bind(this, '/regional-admin-dashboard/0')}>Dashboard</MenuItem>
                                 <MenuItem key={'Reports'} onClick={this.handleClose.bind(this, '/surveyreports')}>Reports - External</MenuItem>
                            </MenuList>
                        </ClickAwayListener>
                    )
                default:
                    return (
                        <span />
                    )
            }
        }
        else {
            return (
                <span />
            );
        }
    }

    renderSystemNotifications() {
        const elements: any = [];

        if (this.state.notifications && this.state.notifications.length > 0) {
            elements.push(
                <ApplicationMain>
                    <Button onClick={this.clearAll} className="clearAllNotification">
                        Clear All
    </Button>
                </ApplicationMain>
            )
            this.state.notifications.forEach((notification: any, notificationIndex: any) => {
                elements.push(
                    <MenuItem
                        key={notification.id}
                        onClick={this.handleCloseNotification}
                        className="listNotifyIcon"
                    >
                        <PriorityHighIcon />
                        <p>{notification.text}</p>
                        <div>
                            <IconButton onClick={this.markAsRead.bind(this, notification.id, notificationIndex)} color="inherit" aria-label="Mark As Read" title="Mark As Read">
                                <MarkUnreadIcon />
                            </IconButton>
                            {
                                notification && notification.type && (notification.type === 3 || notification.type === 4 || notification.type === 5) ?
                                    <IconButton onClick={this.navigateToResponse.bind(this, notification.countryModuleSurveyMappingId, notification.pageNumber, notification.questionId, notification.moduleId, notification.type)} color="inherit" aria-label="See Comment" title="See Comment">
                                        <OpenInNewIcon />
                                    </IconButton>
                                    :
                                    ''
                            }
                        </div>
                    </MenuItem>
                );
            });
        }

        return elements;
    }

    clearAll = () => {
        clearAllNotification().then((res: any) => {
            if (res.data && res.data.success) {
                this.handleCloseNotification();
                let notificationsCount: number = 0;
                getNotificationsCount().then((resCount: any) => {
                    if (resCount.data && resCount.data.success) {
                        notificationsCount = resCount.data.payload;
                    }

                    this.setState({ notificationsCount });
                });
            }
        });
    }

    markAsRead(notificationId: any, notificationIndex: any) {
        markAsReadNotification(notificationId).then((res: any) => {
            if (res.data && res.data.success) {
                const notifications = this.state.notifications;
                notifications.splice(notificationIndex, 1);
                this.setState({ notifications,notificationsCount:notifications.length});
            }
        });
    }

    navigateToResponse(countryModuleSurveyMappingId: any, pageNumber: any, questionId: any, moduleId: number, type: number) {
        if (countryModuleSurveyMappingId > 0 && pageNumber > 0 && questionId && type !== 5) {
            this.context.router.history.push(`/survey/response/${countryModuleSurveyMappingId}/${pageNumber}/${questionId}`);
        } else if (moduleId && moduleId > 0 && type === 5) {
            this.context.router.history.push(`/reviewQuestions/${moduleId}/${pageNumber}/${questionId}`);
        }
    }

    handleDialogLogoutInOfflineMode() {
        const loggedInUser = getLocalStorageValue('user');
        this.setState({ isConfirmDialogShow: false });

        if (loggedInUser && loggedInUser.isInternalUser) {
            localStorage.removeItem(`UserId_${loggedInUser.id}_${SYNC_SURVEY_GET_USER_COUNTRIES_KEY}`)
            localStorage.removeItem('user');
            this.props.logout();

            getAdalConfig().then((adalConfig) => {
                if (adalConfig) {
                    const authContext = new AuthenticationContext(adalConfig)
                    authContext.logOut();
                }
            })

        }
        else {
            if (loggedInUser) {
                localStorage.removeItem(`UserId_${loggedInUser.id}_${SYNC_SURVEY_GET_USER_COUNTRIES_KEY}`)
            }
            localStorage.removeItem('user');
            this.props.logout();
            this.props.redirectTo("/login");
        }
    }

    render() {
        return (
            <AppHeaderWrapper>
                <ConfirmationComponent onCloseConfirmation={this.onCloseConfirmation} handleDialogSubmit={this.handleDialogLogoutInOfflineMode} message={LOGOUT_WARNING_IN_OFFLINE_MODE_CONFIRAMATION} open={this.state.isConfirmDialogShow} />
                {this.state.showHeader &&
                    <div className="header">
                        <AppBar position="static">
                            <Toolbar className="headerToolbar">
                                <IconButton onClick={this.handleToggle} /* buttonRef={this.setAnchorMenu} */
                                    className={this.state.open ? "menuButton" : ""}
                                    color="inherit"
                                    aria-label="Open drawer"
                                    title="Main Nav">
                                    <AppsIcon />
                                </IconButton>

                                <div className="">
                                    <Popper open={this.state.open} transition={true} /* anchorEl={this.anchorElMenu}  */ disablePortal={true} className="popperMenu">
                                        {({ TransitionProps, placement }) => (
                                            <Grow
                                                {...TransitionProps}
                                                style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                                            >
                                                {this.sortMenu()}
                                            </Grow>
                                        )}
                                    </Popper>
                                </div>

                                <Typography className="headerTitle" variant="h6" color="inherit" noWrap={true}>
                                    NutriDash 3.0
                </Typography>

                                {
                                    !this.state.isOfflineModeActive || !this.props.isOfflineModeActivated ?
                                        <div className="grow" />
                                        :
                                        <div className="offlineAlertMsg" >
                                            Disclaimer: Please do not close, refresh or clear browser cache/history to avoid loss of data entered on offline!
                   </div>

                                }

                                <div className="sectionDesktop">
                                    {
                                        !this.state.isOfflineModeActive || !this.props.isOfflineModeActivated ?
                                            <div className="notificationSection">
                                                {this.state.notificationOpen}
                                                <IconButton onClick={this.handleNotificationToggle}
                                                    buttonRef={this.setAnchorNotification}
                                                    className={this.state.notificationOpen ? "menuButton" : ""} color="inherit" aria-label="Open drawer" title="Notifications">
                                                    <Badge badgeContent={this.state.notificationsCount ? this.state.notificationsCount : 0} color="secondary" className="notificationBadge">
                                                        <NotificationsIcon />
                                                    </Badge>
                                                </IconButton>
                                                <div className="">
                                                    <Popper open={this.state.notificationOpen} anchorEl={this.anchorElNotification} transition={true} disablePortal={true} className="popperNotificationMenu">
                                                        {({ TransitionProps, placement }) => (
                                                            <Grow
                                                                {...TransitionProps}
                                                                style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                                                            >
                                                                {/* <ClickAwayListener onClickAway={this.handleCloseNotificationAway}> */}

                                                                <MenuList className="appMenuList">
                                                                    {
                                                                        this.state.notifications && this.state.notifications.length > 0 ?
                                                                            this.renderSystemNotifications()
                                                                            :
                                                                            <MenuItem><PriorityHighIcon />No new notifications found!!!</MenuItem>
                                                                    }
                                                                </MenuList>
                                                                {/* </ClickAwayListener> */}
                                                            </Grow>
                                                        )}
                                                    </Popper>
                                                </div>

                                            </div>
                                            : ''
                                    }
                                    <IconButton
                                        aria-owns={'material-appbar'}
                                        aria-haspopup="true"
                                        color="inherit"
                                        title={getLocalStorageValue('user') ? "Logout (" + getLocalStorageValue('user').email + ")" : "Logout"}
                                    >
                                        <PowerSettingsNewIcon className="logoutUser" onClick={this.logoutUser} />
                                    </IconButton>
                                </div>

                            </Toolbar>
                        </AppBar>
                    </div>
                }
            </AppHeaderWrapper >
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        loggedInUser: state.userAuth.loggedInUser,
        setCountry: state.userAuth.setCountry,
        isOfflineModeActivated: state.model.isOfflineModeActivated
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (path: string) => dispatch(push(path)),
        logout: () => dispatch(logout()),
        setSurveyOfflineMode: (data: any) => dispatch(setSurveyOfflineModeAction(data))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(HeaderComponent);


// WEBPACK FOOTER //
// ./src/components/common/header/HeaderComponent.tsx